import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { captureError } from 'shared/base';
import { CARD_HEADER_HEIGHT, CHART_CONTENT_HEIGHT } from 'shared/features/reportCard/constants';

interface Props {
  children: React.ReactNode;
  title: string;
}

interface State {
  error: any;
}

export class ReportItemErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    captureError(`Platform reports error while rendering report item: ${error.message}`, {
      componentStack: errorInfo.componentStack,
      errorInfo,
      errorStack: error.stack,
    });
  }

  render() {
    const { children, title } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <Card>
          <Stack
            alignItems="center"
            borderBottom="1px solid"
            borderColor="divider"
            direction="row"
            height={CARD_HEADER_HEIGHT}
            justifyContent="space-between"
            paddingBlockEnd={1.5}
            paddingBlockStart={1.5}
            paddingInlineEnd={1.5}
            paddingInlineStart={2.5}
            sx={{
              backgroundColor: (theme) => theme.palette.secondary.darkMedium,
              borderRadius: '8px 8px 0 0',
            }}
          >
            <Stack alignItems="center" direction="row" spacing={1}>
              <Typography variant="h6">{title}</Typography>
            </Stack>
          </Stack>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              minHeight: CHART_CONTENT_HEIGHT,
              minWidth: '33%',
              padding: '1.25rem',
            }}
          >
            <Typography variant="body2">{error.message}</Typography>
          </Box>
        </Card>
      );
    }

    return children;
  }
}
